export const SNACKBAR_RENDER = 'SNACKBAR_RENDER'
export const SNACKBAR_CLOSE = 'SNACKBAR_CLOSE'

export function renderSnackbar(snackbar) {
  return {
    type: SNACKBAR_RENDER,
    snackbar
  }
}

export function closeSnackbar() {
  return {
    type: SNACKBAR_CLOSE
  }
}



// WEBPACK FOOTER //
// ./src/actions/snackbar.js